import React, { useState } from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import { Tooltip } from 'components/Common/Tooltip/Tooltip';
import Loading from 'components/Loading';

function Footer({ footerProps }) {

  const {
    invalid = false,
    invalidTooltipDescriptions = [],
    submitLoading = false,
    title = '',
    handleClose = (() => {return}),
    handleSubmitForm = (() => {return}),
  } = footerProps;

  const [required] = useState(Array.isArray(invalidTooltipDescriptions) && invalidTooltipDescriptions.length > 0)

  return (
    <>
      <Container className='p-0 m-0'>
        <Row className="d-flex justify-content-between align-items-center w-100">
          <Col className='d-flex justify-content-start align-items-center'>{required ? '* = required field' : ''}</Col>
          <Col className='d-flex justify-content-end align-items-center p-0 m-0'>
            <Button
              data-intercom-target={"close-modal-button-add-site"}
              variant="primary"
              className="mr-2"
              onClick={() => {
                handleClose?.();
              }}
            >
              Close
            </Button>
            {invalid
              ?
                <Tooltip
                  placement="top"
                  description={
                    <ul className="m-0 pl-3 text-left">
                      {invalidTooltipDescriptions?.map(d => {
                        const {title = '', message = '', id = null} = d?.message;
                        // const title  = d?.title?.message?.title;
                        // const message  = d?.title?.message?.message;
                        // const id  = d?.title?.message?.id;
                        return (
                          <li key={id}><span className='font-weight-bold mr-1'>{title}</span>{message}</li>
                        )
                      })}
                    </ul>
                  }
                >
                  <Button variant="success" className='disabled' onClick={() => {return}} data-intercom-target={`submit-${title}-form`}>Submit</Button>
                </Tooltip>
              :
                <Button variant="success" onClick={handleSubmitForm} data-intercom-target={`submit-${title}-form`}>
                  {submitLoading ? <Loading /> : "Submit"}
                </Button>
            }
          </Col>
        </Row>      
      </Container>
    </>
  )
}

export default Footer
